import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import {
  selectBasicInformation,
  selectIsLoadingSomeData,
} from '../../../common/store/slice'
import classes from './index.module.scss'
import { IndicatorItem } from './IndicatorItem'

export const BasicInformation = () => {
  const basicInformation = useSelector(selectBasicInformation)
  const isLoadingSomeData = useSelector(selectIsLoadingSomeData)

  return (
    <Element elementName="ul" className={classes.infoList}>
      {isLoadingSomeData ? (
        <Loading />
      ) : basicInformation.length === 0 ? (
        <></>
      ) : (
        basicInformation.map((item) => (
          <IndicatorItem key={item.screeningIndicatorId} item={item} />
        ))
      )}
    </Element>
  )
}
